<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card title="Gestion des publications">
          <va-tabs v-model="tabIndex">
            <va-tab>Gestion des numéros</va-tab>
            <va-tab>Résultats</va-tab>
          </va-tabs>
          <div
            class="flex md12"
            v-show="tabIndex === 0"
          >
            <div class="row row-inside">
              <div class="flex md12">
                <div class="row row-inside">
                  <div
                    class="flex md2"
                    v-for="element in yearList"
                  >
                    <va-button
                      class="fullwidth"
                      :color="element === activeYear ? 'success' : 'info'"
                      @click="activeYear = element"
                    >{{ element }}</va-button>
                  </div>
                </div>
              </div>
              <div class="flex md6">
                <div class="row row-inside">
                  <div
                    class="flex md2 container ma-2"
                    v-for="element in activeNumbers"
                    :style="backgroundColor(element)"
                    @click="openNumero(element)"
                  >
                    <div class="numero-box">
                      {{ element.numero }}
                    </div>
                    <div class="date-box">
                      {{
                        moment(
                          element.date_previsionnelle,
                          "YYYY-MM-DD"
                        ).format("DD-MM-YYYY")
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex md6">
                <div class="row row-inside">
                  <div
                    class="flex md2 container ma-2"
                    v-for="element in activeHS"
                    :style="backgroundColor(element)"
                    @click="openNumero(element)"
                  >
                    <div class="hors-series-text">HORS-SERIE</div>

                    <div class="date-box">
                      {{
                        moment(element.date_previsionnelle).format("DD-MM-YYYY")
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="flex md3 offset--md9"
                v-if="this.$store.getters.user.publications_numeros"
              >
                <va-button
                  color="info"
                  @click="createNew()"
                >
                  <va-icon
                    size="15px"
                    name="fa fa-plus"
                  />
                  <span>&nbsp Ouvrir un numéro</span></va-button>
              </div>
            </div>
          </div>
          <div
            class="flex md12"
            v-show="tabIndex === 1"
          >
            <div class="row row-inside">A préciser</div>
          </div>
        </va-card>
      </div>
    </div>
    <edit-publication
      v-model="showEditPublication"
      :idnumero="idnumero"
      @close="closeViewer"
      @modification="updateList"
    />
    <create-publication
      v-model="showCreatePublication"
      @creation="updateList"
    />
    <view-publication
      v-model="showPublication"
      :idnumero="idnumero"
      @close="closeViewer"
    />
  </div>
</template>

<script>
import axios from "axios";
import EditPublication from "./numeroEdition";
import CreatePublication from "./numeroCreation";
import ViewPublication from "./numero";
import { sortedUniq, sortBy } from "lodash";
import moment from "moment";

export default {
  name: "publications-list",
  props: ["idnumero", "edition"],
  components: { EditPublication, CreatePublication, ViewPublication },
  data() {
    return {
      showCreatePublication: false,
      showEditPublication: false,
      showPublication: false,
      tabIndex: 0,
      publicationsList: [],
      activeYear: null,
      //export within context
      moment: moment,
    };
  },
  created() {
    this.updateList();
  },
  watch: {
    idnumero: {
      immediate: true,
      handler(newvalue) {
        if (this.edition === "edit" && newvalue) {
          this.showEditPublication = true;
          this.showPublication = false;
          this.showCreatePublication = false;
        } else if (newvalue) {
          this.showEditPublication = false;
          this.showPublication = true;
          this.showCreatePublication = false;
        } else {
          this.showEditPublication = false;
          this.showPublication = false;
          this.showCreatePublication = false;
        }
      },
    },
    edition: {
      immediate: true,
      handler(newvalue) {
        if (this.edition === "edit" && this.idnumero) {
          this.showEditPublication = true;
          this.showPublication = false;
          this.showCreatePublication = false;
        }
      },
    },
  },
  computed: {
    activeNumbers() {
      let tmpList = this.publicationsList.filter((element) => {
        if (
          element.date_previsionnelle.substring(0, 4) === this.activeYear &&
          !element.hors_serie
        )
          return true;

        return false;
      });

      return tmpList;
    },
    activeHS() {
      let tmpList = this.publicationsList.filter((element) => {
        if (
          element.date_previsionnelle.substring(0, 4) === this.activeYear &&
          element.hors_serie
        )
          return true;

        return false;
      });

      return tmpList;
    },
    yearList() {
      let tmpList = [];
      this.publicationsList.forEach((element) => {
        tmpList.push(element.date_previsionnelle.substring(0, 4));
      });

      tmpList = sortedUniq(sortBy(tmpList));

      if (!this.activeYear) {
        this.activeYear = tmpList[0];
      }

      return tmpList;
    },
  },
  methods: {
    closeViewer() {
      this.$router.push({
        name: "liste-publication",
      });
    },
    openNumero(element) {
      this.$router.push({
        name: "liste-publication",
        params: { idnumero: element.idpublication },
      });
      this.showPublication = true;
    },
    backgroundColor(element) {
      if (element.isactif) {
        return { backgroundColor: "#4ae387" };
      } else if (element.date_cloture) {
        return { backgroundColor: "#ccc" };
      } else {
        return { backgroundColor: "#4ab2e3" };
      }
    },
    async updateList() {
      try {
        let temp = await axios.get("/api/publications/list");
        this.publicationsList = temp.data;
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast(
          "Erreur lors de la récupération de la liste des publications"
        );
      }
    },
    createNew() {
      if (this.idnumero) {
        return;
      }
      this.showCreatePublication = true;
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fullwidth {
  width: 95%;
}

.container {
  text-align: center;
  min-height: 6em;
}

.container:hover {
  cursor: pointer;
}

.numero-box {
  color: white;
  font-size: 1.5em;
  font-weight: bold;
}

.hors-series-text {
  color: white;
  font-size: 1em;
  font-weight: bold;
}

.date-box {
  color: white;
}
</style>
